import { fetch } from 'wix-fetch';

const getCacheKiller = () => {
	return new Date().getTime();
};

const log = (endpoint, src, evId, params) => {

	const paramsKeyValue = Object.keys(params || {})
		.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);

	const biParams = paramsKeyValue.join('&');
	
	const url = `https://frog.wix.com/${endpoint}?src=${src}&evid=${evId}&${biParams}&_=${getCacheKiller()}`;
	
	return fetch(url, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
	.then(response => {
		// console.log('Bi response:', response.ok)
		return (response.ok);
	}).catch(error => {
		return error;
	});
};

export function biActionLinkButton(params) { log('developer-center', 96, 16, params) }
// log: (evId, params) => log('platform-cm', 83, evId, params) //Depends on the event number and call you want to send
